module.exports = __webpack_public_path__ + "img/icon-url.e27714fd.svg";